<script setup lang="ts">
  import { X } from 'lucide-vue-next';
  import { cn } from '@/shared/lib/utils';
  import type { HTMLAttributes } from 'vue';

  interface Props {
    label: string;
    removable?: boolean;
    class?: HTMLAttributes['class'];
  }

  const props = withDefaults(defineProps<Props>(), {
    removable: true,
    class: undefined,
  });

  defineEmits<{
    (e: 'remove'): void;
  }>();
</script>

<template>
  <span
    :class="
      cn(
        'inline-flex items-center gap-1 h-[22px] px-3 py-1 rounded-full bg-[var(--color-gray-02)] text-sm font-normal text-[var(--color-gray-07)]',
        props.class
      )
    "
  >
    {{ label }}
    <button
      v-if="removable"
      type="button"
      :aria-label="`Remover ${label}`"
      class="inline-flex items-center justify-center cursor-pointer"
      @click="$emit('remove')"
    >
      <X class="size-3 text-[var(--color-gray-07)]" />
    </button>
  </span>
</template>
